import template from "./change-organization-modal.html";

const ChangeOrganizationModalComponent = {
  bindings: {
    dismiss: "&",
  },
  template: template,
  controller: class ChangeOrganizationModalController {
    /* @ngInject */
    constructor($state, $rootScope, User, SecurityManager) {
      this.$rootScope = $rootScope;
      this.$state = $state;
      this.User = User;
      this.SecurityManager = SecurityManager;
    }

    $onInit() {
      this.loading = false;
      this.initValues();
    }

    initValues() {
      this.organizations = this.$rootScope.user.organizations;
      this.currentOrganization = this.$rootScope.organization;
      this.defaultOrganization = this.$rootScope.user.defaultOrganization;
    }

    async updateDefaultOrganization(defaultOrganization) {
      this.loading = true;
      await this.User.updateDefaultOrganization(defaultOrganization.id);
      await this.SecurityManager.refreshUser();
      this.initValues();
      this.loading = false;
      this.$rootScope.$applyAsync();
    }

    goCreateOrganization() {
      this.$state.go("createOrganization");
    }

    isOwner(organization) {
      return organization.owner.id === this.$rootScope.user.id;
    }

    isCurrentOrganization(organization) {
      return organization.id === this.currentOrganization.id;
    }

    showCreateOrganization() {
      if (process.env.ENV !== "prod") {
        return !this.organizations.some((organization) => this.isOwner(organization));
      }
    }

    isDefaultOrganization(organization) {
      return organization.id === this.defaultOrganization.id;
    }

    cancel() {
      this.dismiss({ $value: "cancel" });
    }
  },
};

export default ChangeOrganizationModalComponent;
